export default __webpack_public_path__ + "static/media/tech-support-white.60a9bc50.svg";